<template>
    <v-dialog v-model="viewCardModal" max-width="430px" :fullscreen="$vuetify.breakpoint.xs ? true : false">
        <v-card class="membership-card-dialog" v-if="membershipCard != null" >
            <v-app-bar flat dense>
                <v-toolbar-title class="text-h6 white--text pl-4">{{ $page.props.lang.membership_card || "Membership card" }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn color="white" icon @click="viewCardModal = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-app-bar>
            <div class="card-details text-center">
                <h3>{{ membershipCard.member_name }}</h3>
                <hr>
                <barcode :value="membershipCard.card_number" displayValue="false" :width="$vuetify.breakpoint.xs ? 1 : 2" height="50"></barcode>
            </div>
            <v-card-text>
                <div class="text-center balance-box" >
                    <span style="font-weight:bold; font-size:20px" v-bind:style="{color:membershipCard.balance < 0 ? 'red':'#55DF7C' }">{{ membershipCard.balance }} {{$page.props.organization.settings.currency}} <br></span>
                    <span>{{ $page.props.lang.balance || "Balance" }}</span>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<style scoped>
.membership-card-dialog{
     background-image: radial-gradient(circle,#612566 4%, #ae1a5f 100%) !important;
     color:#fff;
}

.v-toolbar__content{
    background-image: none;
    color:red;
}

.card-details{
    background:#fff;
    margin: 0px 30px 20px 30px;
    border-radius: 5px;
    color:#000;
}

.card-details h3 {
    padding:10px 0;
}

.balance-box {
    color: #fff;
    padding:20px;
    background: rgba(255, 255, 255, 0.4);
    border-radius: 5px;
    margin: 0px 6px;
}


</style>

<script>

import VueBarcode from 'vue-barcode';
import EventBus from '../../../../eventbus';

export default {
    props: {
        open: Boolean
    },
    data(){
        return {
            membershipCard: null
        }
    },
    components: {
       'barcode': VueBarcode
    },
    computed: {
        viewCardModal: {
            get: function() {
                return this.open
            },
            set: function(newValue) {
                EventBus.$emit('CLOSE_MEMBERSHIP_CARD_MODAL')
                return newValue
            }
        }
    },
    created(){
        this.getMembershipData();
    },
    methods: {

        getMembershipData() {

             axios.get('/portal/card/details')
                .then(response => {
                    if (response.data.status==="OK") {
                        this.membershipCard = response.data.data;
                        
                    } else {
                        EventBus.$emit('SHOW_NOTIFICATION', {
                            message: response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    }
                })
                .catch((e) => {
                    
                })

        }
    }
}
</script>
